import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import PrimerValidationErrorAndroid from '../vault/_common/vaultValidationError.mdx';
import PrimerErrorPropsAndroid from '../../common/primerErrorProps.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Item title={`componentValidationStatus: Flow<PrimerValidationStatus<${props.collectableData}>>`} mdxType="Item">
      <p>{`The `}<inlineCode parentName="p">{`PrimerValidationStatus`}</inlineCode>{` interface encompasses a range of validation statuses.`}</p>
      <Group summary='sealed interface PrimerValidationStatus' mdxType="Group">
        <Item title={`Validating<${props.collectableData}>`} mdxType="Item">
  Indicates that data is currently in the process of being validated.
    <Group summary='Properties' open mdxType="Group">
      <Item title='collectableData' subtitle={`${props.collectableData}`} mdxType="Item">
              <p>{`The data being validated.`}</p>
  </Item>
  </Group>
        </Item>
        <Item title={`Valid<${props.collectableData}>`} mdxType="Item">
Indicates that the data has successfully been validated.
          <Group summary='Properties' open mdxType="Group">
            <Item title='collectableData' subtitle={`${props.collectableData}`} mdxType="Item">
              <p>{`The successfully validated data.`}</p>
  </Item>
 </Group>
 </Item>
        <Item title={`Invalid<${props.collectableData}>`} mdxType="Item">
Indicates that the data has been considered invalid after validation.
          <Group summary='Properties' open mdxType="Group">
            <Item title='validationErrors' subtitle='List<PrimerValidationError>' mdxType="Item">
              <p>{`List of `}<inlineCode parentName="p">{`PrimerValidationError`}</inlineCode>{` objects that represent data validation errors emitted by this component.`}</p>
 <Group mdxType="Group">
    <PrimerValidationErrorAndroid mdxType="PrimerValidationErrorAndroid" />
 </Group>
            </Item>
            <Item title='collectableData' subtitle={`${props.collectableData}`} mdxType="Item">
              <p>{`The data that failed validation.`}</p>
  </Item>
 </Group>
 </Item>
        <Item title={`Error<${props.collectableData}>`} mdxType="Item">
Represents the status when an error occurred during the validation process.
          <Group summary='Properties' open mdxType="Group">
            <Item title='error' subtitle='PrimerError' mdxType="Item">
              <p>{`The specific `}<inlineCode parentName="p">{`PrimerError`}</inlineCode>{` that occurred during validation.`}</p>
 <Group mdxType="Group">
    <PrimerErrorPropsAndroid mdxType="PrimerErrorPropsAndroid" />
 </Group>
            </Item>
            <Item title='collectableData' subtitle={`${props.collectableData}`} mdxType="Item">
              <p>{`The data for which the error occurred.`}</p>
  </Item>
 </Group>
 </Item>
 </Group>
 </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      